define('modules/private/view-mdsidebar',['require','exports','module','backbone','i18n','react','react-dom','mdsidebarjs','ServicesHelper','ThemesHelper','./authInfo'],function (require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
    i18n = require("i18n"),
    React = require("react"),
    ReactDOM = require("react-dom"),
    MDSidebar = require("mdsidebarjs"),
    ServicesHelper = require("ServicesHelper"),
    ThemesHelper = require("ThemesHelper"),
    AuthInfo = require("./authInfo");

  var MDSidebarJS = Backbone.View.extend({
    userLang: i18n.lng(),
    services: [],
    initialize: function (options) {
      this.userLang = i18n.lng();
      // Search in local storage for services:
      if (this.model) {
        this.listenTo(this.model, "sync", this.loadServices);
      }
    },

    collapseSidebar: function () {
      $("#md__sidebar__wrapper").addClass("collapsed");
    },

    loadServices: function () {
      $.when(ServicesHelper.getServices()).done(
        function (response) {
          this.services = ServicesHelper.parseServices(
            response._embedded.services
          );
          if (this.isGoodDataService(response._embedded.services)) {
            localStorage.setItem(
              this.getStoreKeyServices(),
              JSON.stringify(this.services)
            );
          }
          this.render();
        }.bind(this)
      );
    },

    getStoreKeyServices: function () {
      return (
        "my-services-v2-" + this.model.getGroup() + "-" + this.model.getUID()
      );
    },

    isGoodDataService: function (services) {
      if (!services || !services.length) {
        return false;
      }
      var valid = true;
      services.map(function (service) {
        if (!service.rolId) valid = false;
      });

      return valid;
    },

    setUserLang: function (lang) {
      this.userLang = lang;
      return this;
    },

    render: function () {
      var sidebarContainer = document.getElementById("md__sidebar__wrapper");

      if (!sidebarContainer) {
        return;
      }

      var authInfo = new AuthInfo(this.model);

      var sidebarOptions = {
        lang: this.userLang,
        theme: ThemesHelper.getCurrentTheme(),
        servicesConfig: this.services,
        companyId: authInfo.getCompanyId(),
        groupId: this.model.getGroup(),
        userId: this.model.getUID(),
        isEmBlue: this.model.isEmBlue(),
      };

      ReactDOM.render(
        React.createElement(MDSidebar.MDSidebar, sidebarOptions),
        document.getElementById("md__sidebar__wrapper")
      );

      return this;
    },
  });
  module.exports = MDSidebarJS;
});

